import { render } from "./mizeadd.vue?vue&type=template&id=6ba2d72e&scoped=true"
import script from "./mizeadd.vue?vue&type=script&lang=js"
export * from "./mizeadd.vue?vue&type=script&lang=js"

import "./mizeadd.vue?vue&type=style&index=0&id=6ba2d72e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ba2d72e"]])

export default __exports__